//menu
$(document).ready(function () {
  $('#menu_icon').click(function () {
    $(this).toggleClass('active');
    if ($(this).hasClass('active')) {
      $('#header_bot').addClass('active');
      $('#header').addClass('active');
      $('#header_bot').css('height', $(window).height() - $('#header').height());
      $('body').css('overflow', 'hidden');
    } else {
      $('#header_bot').removeClass('active');
      $('#header').removeClass('active');
      $('#header_bot').removeAttr('style');
      $('body').removeAttr('style');
    }
  });
  $(window).on('resize', function () {
    $('#header_bot').css('height', $(window).height() - $('#header').height());
  });
});

// cart and add item
$(document).ready(function () {
  /* -------------------------
   * 汎用ヘルパー
   * ------------------------- */

  // 数値化（負値は0止め）
  function toSafeQty(v, fallback) {
    const n = parseInt(String(v).replace(/[^\d\-]/g, ''), 10);
    if (isNaN(n)) return fallback;
    return n < 0 ? 0 : n;
  }

  // 行コンテキスト（line key / line / variant id を拾う）
  function getLineContext(node) {
    const row = node.closest('[data-line-key],[data-cart-line],[data-variant-id]');
    if (!row) return {};
    return {
      row,
      lineKey: row.getAttribute('data-line-key') || node.getAttribute('data-line-key') || '',
      line: row.getAttribute('data-cart-line') || node.getAttribute('data-cart-line') || '',
      variantId: row.getAttribute('data-variant-id') || node.getAttribute('data-variant-id') || '',
    };
  }

  // 行のロック（多重操作防止）
  function lockRow(row, locked) {
    if (!row) return;
    row.classList.toggle('is-busy', !!locked);
    row.querySelectorAll('.btn_plus,.btn_minus,.btn_remove,.cart-quantity').forEach((el) => {
      if ('disabled' in el) el.disabled = !!locked;
      el.style.pointerEvents = locked ? 'none' : '';
      el.style.opacity = locked ? '0.6' : '';
    });
  }

  // 件数バッジを更新＋小アニメ
  function bumpHeaderCount(count, animate = true) {
    const $badge = $('#count-cart');
    if (!$badge.length) return;
    $badge.text(count);
    if (!animate) return;
    $badge.css('will-change','transform');
    $badge.css('transform','scale(1.5)');
    setTimeout(() => { $badge.css('transform','scale(1)'); }, 200);
  }


  // ミニカート再描画（“可視時だけ”HTML差し替え、非表示なら件数のみ同期）
  function refreshMiniCart(cartObj, animateBadge = false) {
    const $wrap = $('#header_cart_items');
    if ($wrap.length && $wrap.is(':visible')) {
      $('#header_cart_items').load('/cart #cart_items_page', function () {
        if (typeof initializeGiftCheckbox === 'function') initializeGiftCheckbox();
      });
    } else if (cartObj && typeof cartObj.item_count === 'number') {
      bumpHeaderCount(cartObj.item_count, animateBadge); // ここはふつうアニメ=falseで呼ぶ
    }
  }

  /* -------------------------
   * 通信（できるだけ1回で）
   * ------------------------- */
  // カートページ判定
  // 言語プレフィックス付きURLや末尾スラッシュにも対応
  function isCartPage() {
    var path = window.location.pathname.replace(/\/$/, '');
    return path === '/cart' || /\/cart$/.test(path);
  }

  // 数量1のときはマイナスボタンを無効化
  function updateMinusState(scope) {
    var $scope = scope ? $(scope) : $(document);

    $scope.find('.quantity').each(function () {
      var $quantity = $(this);
      var $input = $quantity.find('.cart-quantity');
      var $minus = $quantity.find('.btn_minus');
      var value = parseInt(String($input.val() || '').replace(/[^\d]/g, ''), 10);
      var isDisabled = isNaN(value) || value <= 1;

      $minus
        .toggleClass('is-disabled', isDisabled)
        .attr('aria-disabled', isDisabled ? 'true' : 'false');
    });
  }

  // 数量は最小1に補正
  function normalizeCartQty(input) {
    var $input = $(input);
    var value = parseInt(String($input.val() || '').replace(/[^\d]/g, ''), 10);

    if (isNaN(value) || value < 1) {
      value = 1;
    }

    $input.val(value);
    return value;
  }

  // 送信ユーティリティ：即時1発（key>line>variant）
  function sendQtyNow(ctx, nextQty, animateBadge = true) {
    const row = ctx.row;
    // ロックは最小限（体感重さを減らす）
    if (row) row.classList.add('is-busy');

    return applyQty(ctx, nextQty)
    .then(cart => {
      if (cart && typeof cart.item_count === 'number') {
        bumpHeaderCount(cart.item_count, animateBadge); // バッジはここで1回だけアニメ
      }
      if (isCartPage()) {
        window.location.reload();
        return;
      }
      refreshMiniCart(cart, false);
    })
    .catch(err => {
      console.error('qty change failed', err);
      refreshMiniCart(undefined, false);
    })
    .finally(() => {
      if (row) row.classList.remove('is-busy');
    });
  }

  function postForm(url, payloadObj) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
      body: new URLSearchParams(payloadObj),
      credentials: 'same-origin',
    }).then((r) => {
      if (!r.ok) throw r;
      return r.json(); // /cart/change.js, /cart/update.js はカートJSON
    });
  }

  // 推奨：line item key で変更（/cart/change.js は id に key を渡す）
  function changeByKey(lineKey, qty) {
    return postForm('/cart/change.js', { id: lineKey, quantity: String(qty) });
  }
  // 保険：line番号で変更
  function changeByLine(line, qty) {
    return postForm('/cart/change.js', { line: String(line), quantity: String(qty) });
  }
  // 最終手段：variant単位で合算更新
  function updateByVariant(variantId, qty) {
    const p = new URLSearchParams();
    p.append(`updates[${variantId}]`, String(qty));
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
      body: p,
      credentials: 'same-origin',
    }).then((r) => {
      if (!r.ok) throw r;
      return r.json();
    });
  }

  // Key → Line → Variant の順で適用
  function applyQty(ctx, qty) {
    if (!ctx) return Promise.reject('no-ctx');
    const { lineKey, line, variantId } = ctx;
    const tryKey = lineKey ? () => changeByKey(lineKey, qty) : () => Promise.reject('no-key');
    const tryLine = line ? () => changeByLine(line, qty) : () => Promise.reject('no-line');
    const tryVar = variantId ? () => updateByVariant(variantId, qty) : () => Promise.reject('no-variant');
    return tryKey().catch(tryLine).catch(tryVar);
  }

  /* -------------------------
   * 数量入力（デバウンス）
   * ------------------------- */

  let qtyTimer = null;

  // 一部テーマは change しか飛ばない対策：change を input に変換
  // document.addEventListener('change', function (e) {
  //   const input = e.target.closest('.cart-quantity');
  //   if (input) input.dispatchEvent(new Event('input', { bubbles: true }));
  // });

  document.addEventListener('input', function (e) {
    var input = e.target.closest('.cart-quantity');
    if (!input) return;

    var ctx = getLineContext(input);
    var row = input.closest('.sb_df') || ctx.row;
    var next = normalizeCartQty(input);

    updateMinusState(row);

    clearTimeout(qtyTimer);
    qtyTimer = setTimeout(function () {
      sendQtyNow(ctx, next, true);
    }, 120);
  });

  /* -------------------------
   * + / - / Remove（委譲）
   * ------------------------- */

  document.addEventListener('click', function (e) {
    // + ボタン
    const plus = e.target.closest('.btn_plus');
    if (plus) {
      e.preventDefault();

      var input = plus.parentNode.querySelector('.cart-quantity');
      if (!input) return;

      var ctx = getLineContext(input);
      var row = input.closest('.sb_df') || ctx.row;
      var next = (parseInt(String(input.value || '').replace(/[^\d]/g, ''), 10) || 1) + 1;

      input.value = next;
      updateMinusState(row);

      sendQtyNow(ctx, next, true);
      return;
    }

    // - ボタン
    const minus = e.target.closest('.btn_minus');
    if (minus) {
      e.preventDefault();

      if ($(minus).hasClass('is-disabled')) {
        return;
      }

      var input = minus.parentNode.querySelector('.cart-quantity');
      if (!input) return;

      var ctx = getLineContext(input);
      var row = input.closest('.sb_df') || ctx.row;
      var current = parseInt(String(input.value || '').replace(/[^\d]/g, ''), 10) || 1;
      var next = Math.max(1, current - 1);

      input.value = next;
      updateMinusState(row);

      sendQtyNow(ctx, next, true);
      return;
    }

    // Remove
    const remove = e.target.closest('.btn_remove');
    if (remove) {
      e.preventDefault();

      const ctx = getLineContext(remove);
      const row = remove.closest('.sb_df') || ctx.row;

      if (row) row.style.opacity = '0.5';

      sendQtyNow(ctx, 0, true)
        .then(function () {
          if (isCartPage()) {
            window.location.reload();
            return;
          }

          if (row) {
            $(row).slideUp(120, function () {
              $(this).remove();
            });
          }
        })
        .catch(function () {
          if (row) row.style.opacity = '';
        });

      return;
    }
  });


  /* -------------------------
   * Gift Checkbox
   * ------------------------- */

  function initializeGiftCheckbox() {
    // モーダルカート内のスクロール用の高さ指定
    /*
    const cart_max_height = window.innerHeight / 2;
    $('#header_cart_items .sb_bd').css('max-height', cart_max_height + 'px');
    */

    const giftWrappingCheckbox = document.getElementById('gift-wrapping');
    if (!giftWrappingCheckbox) return;

    const giftWrapVariantId = giftWrappingCheckbox.getAttribute('data-variant-id');

    // 現在のカートと同期（既に入っていたらチェックON）
    function syncGiftState() {
      fetch('/cart.js')
        .then((r) => r.json())
        .then((cart) => {
          const giftExists = cart.items.some(
            (item) => item.variant_id === parseInt(giftWrapVariantId)
          );
          giftWrappingCheckbox.checked = giftExists;
          bumpHeaderCount(cart.item_count, false);
        })
        .catch((e) => console.error('Error fetching cart details:', e));
    }

    // バリアントID単位で数量を1/0に“直接”設定（フォームエンコード）
    function setGiftQty(qty) {
      const body = new URLSearchParams();
      body.append(`updates[${giftWrapVariantId}]`, String(qty));
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
        credentials: 'same-origin',
        body
      }).then(r => { if (!r.ok) throw r; return r.json(); });
    }

    // 初期同期
    syncGiftState();

    // 変更ハンドラ
    giftWrappingCheckbox.addEventListener('change', () => {
      giftWrappingCheckbox.disabled = true;
      const wantQty = giftWrappingCheckbox.checked ? 1 : 0;
      setGiftQty(wantQty)
        .then(() => {
          // 必要に応じてミニカートやバッジを更新
          // if (typeof refreshMiniCart === 'function') refreshMiniCart();
          if (cart && typeof cart.item_count === 'number') {
            bumpHeaderCount(cart.item_count, false);
          }

          if (window.location.pathname === '/cart') {
            window.location.reload();
            return;
          }

          refreshMiniCart(cart, false);
        })
        .catch(err => {
          console.error('Gift update failed:', err);
          // 失敗したらUIを元に戻す
          giftWrappingCheckbox.checked = !giftWrappingCheckbox.checked;
        })
        .finally(() => { giftWrappingCheckbox.disabled = false; });
    });
  }

  // 初期化（ミニカートが最初から表示されているケース）
  initializeGiftCheckbox();
  updateMinusState();
});

var $animation_elements = $('.effect');
var $window = $(window);

function check_if_in_view() {
  var window_height = $window.height() * 0.9;
  var window_top_position = $window.scrollTop();
  var window_bottom_position = window_top_position + window_height;
  $.each($animation_elements, function () {
    var $element = $(this);
    var element_height = $element.outerHeight();
    var element_top_position = $element.offset().top;
    var element_bottom_position = element_top_position + element_height;
    //check to see if this current container is within viewport
    if (element_top_position <= window_bottom_position) {
      $element.addClass('active');
    } else {
      $element.removeClass('active');
    }
  });
}
$window.on('scroll resize', check_if_in_view);
if ($('.mCustomScrollbar').length > 0) {
  $('.mCustomScrollbar').mCustomScrollbar({
    axis: 'x',
    theme: 'light-3',
    advanced: { autoExpandHorizontalScroll: true },
  });
}
$(window).scroll(parallax);

function parallax() {
  var scrolledTop = $(window).scrollTop();
  var viewPortHeight = $(window).height();
  if ($('.js-parallaxzoom').length > 0) {
    $('.js-parallaxzoom:in-viewport').run(function () {
      var parallaxZoom = this;
      var distance = parallaxZoom.offset();
      var zoomFactor = 1 + (scrolledTop - distance.top + viewPortHeight) * 0.00005;
      var opacityFactor = 1 + ((scrolledTop - distance.top) / parallaxZoom.height()) * 0.2;
      parallaxZoom.css({
        webkitTransform: 'scale(' + zoomFactor + ') translate3d(0,0,0)',
        MozTransform: 'scale(' + zoomFactor + ') translate3d(0,0,0)',
        msTransform: 'scale(' + zoomFactor + ') translate3d(0,0,0)',
        transform: 'scale(' + zoomFactor + ') translate3d(0,0,0)',
      });
    });
  }
}
var transform = ['transform', 'msTransform', 'webkitTransform', 'mozTransform', 'oTransform'];
function getSupportedPropertyName(properties) {
  for (var i = 0; i < properties.length; i++) {
    if (typeof document.body.style[properties[i]] != 'undefined') {
      return properties[i];
    }
  }
  return null;
}
var transformProperty = getSupportedPropertyName(transform);
function isPartiallyVisible(el) {
  var elementBoundary = el.getBoundingClientRect();
  var top = elementBoundary.top;
  var bottom = elementBoundary.bottom;
  var height = elementBoundary.height;
  return top + height >= 0 && height + window.innerHeight >= bottom;
}
var ParaEles = (function () {
  function ParaEles(el) {
    var p = this;
    this._curr = 0;
    this._step = 0.25;
    this._timer = null;
    var lastScrollTop = 0;
    window.addEventListener(
      'scroll',
      function () {
        var st = window.pageYOffset || document.documentElement.scrollTop;
        if (isPartiallyVisible(el)) {
          if (st > lastScrollTop) {
            p._curr -= p._step;
          } else {
            p._curr += p._step;
          }
          el.style[transformProperty] = 'translate(0px,' + p._curr + 'px) translate3d(0,0,0)';
          if (p._timer !== null) {
            clearTimeout(p._timer);
          }
          p._timer = setTimeout(function () {
            // do something
            el.style[transformProperty] = 'translate(0px,' + p._curr + 'px)';
          }, 150);
        } else {
          el.removeAttribute('style');
          p._curr = 0;
        }
        lastScrollTop = st <= 0 ? 0 : st;
      },
      false
    );
  }
  return ParaEles;
})();
window.addEventListener('DOMContentLoaded', function () {
  Array.prototype.forEach.call(document.querySelectorAll('.parallax'), function (el) {
    new ParaEles(el);
  });
});

$(document).ready(function () {
  if (window.location.href.indexOf('policies/privacy-policy') > -1) {
    $('.shopify-policy__title').addClass('ttl');
    $('.shopify-policy__container').removeClass('shopify-policy__container').css('margin-bottom', '100px');
    $('.shopify-policy__body').addClass('row detail');
  }

  // cart scroll
  /*
  $('#header_cart_items .sb_bd').mCustomScrollbar({
    axis: 'y',
    theme: 'light-3',
    advanced: { autoExpandHorizontalScroll: true },
  });
  */
});

// iOS復帰時に自動再生ビデオを再開
function resumeAutoplayVideos() {
  document.querySelectorAll('video[autoplay][muted]').forEach(v => {
    // 属性だけでなくプロパティも保証（iOSはこっちを見ることがある）
    v.muted = true;
    v.playsInline = true;

    if (v.paused) {
      const t = v.currentTime;
      v.play().catch(() => {
        // プレイが拒否されたら”小突き”で再開を促す
        try {
          // どれか一つで効くケースがある
          v.currentTime = Math.max(0, t + 0.000001);
          // v.load(); // これで読み直すのも有効（ただし再生位置は戻る）
          // v.src = v.src; // 同上
          v.play().catch(()=>{});
        } catch(e){}
      });
    }
  });
}

// ページ復帰系イベントで再開を試す
window.addEventListener('focus', resumeAutoplayVideos);
window.addEventListener('pageshow', resumeAutoplayVideos);
document.addEventListener('visibilitychange', () => {
  if (document.visibilityState === 'visible') resumeAutoplayVideos();
});

// alert を使う時はラッパーで呼ぶ
function iosSafeAlert(msg){
  alert(msg);
  // ダイアログ復帰直後は1ティック待ってから再開
  setTimeout(() => requestAnimationFrame(resumeAutoplayVideos), 0);
}
// 使い方: iosSafeAlert('メッセージ');

// Link add to cart
(function () {
  // ShopifyのロケールURLを考慮してカートURLを取得
  function getCartUrlForLinkAdd() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root + 'cart';
    }

    return '/cart';
  }

  // ---- 失敗時リセット ----
  function afterAddToCartError() {
    document.querySelectorAll('a[data-add-variant].is-busy').forEach(function (a) {
      a.classList.remove('is-busy');
      a.removeAttribute('aria-disabled');
      a.style.pointerEvents = '';
      a.style.opacity = '';
    });
  }

  // ---- クリックハンドラ（委譲） ----
  document.addEventListener('click', function (e) {
    var el = e.target.closest('a[data-add-variant]');
    if (!el) return;

    e.preventDefault();

    // 連打防止
    if (el.classList.contains('is-busy')) return;

    el.classList.add('is-busy');
    el.setAttribute('aria-disabled', 'true');
    el.style.pointerEvents = 'none';
    el.style.opacity = '0.6';

    var variantId = el.getAttribute('data-add-variant');
    var qty = parseInt(el.getAttribute('data-qty') || '1', 10) || 1;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: qty }] }),
      credentials: 'same-origin'
    })
      .then(function (r) {
        if (!r.ok) throw new Error('failed');
        return r.json();
      })
      .then(function () {
        // 成功時はアラートを出さず、必ずカートページへ移動
        window.location.href = getCartUrlForLinkAdd();
      })
      .catch(function () {
        afterAddToCartError();
        iosSafeAlert('カートに追加できませんでした\n商品カラーを選択して在庫状況をご確認ください');
      })
      .finally(function () {
        el.classList.remove('is-busy');
        el.removeAttribute('aria-disabled');
        el.style.pointerEvents = '';
        el.style.opacity = '';
      });
  });
})();

$(function () {
  function getBundleState($form) {
    var state = $form.data('bundle-state');
    var $variantsJson;
    var $skuMapJson;

    if (state) {
      return state;
    }

    state = {
      variants: [],
      skuMap: {}
    };

    $variantsJson = $form.find('script[id^="BundleVariantsJson-"]').first();
    $skuMapJson = $form.find('script[id^="BundleSkuMapJson-"]').first();

    if ($variantsJson.length) {
      try {
        state.variants = JSON.parse($.trim($variantsJson.text()));
      } catch (e) {
        console.error('Bundle variants JSON parse failed:', e);
      }
    }

    if ($skuMapJson.length) {
      try {
        state.skuMap = JSON.parse($.trim($skuMapJson.text()));

        if (typeof state.skuMap === 'string') {
          state.skuMap = JSON.parse(state.skuMap);
        }
      } catch (e) {
        state.skuMap = {};
        console.error('Bundle SKU map JSON parse failed:', e);
      }
    }

    $form.data('bundle-state', state);

    return state;
  }

  function lookupBundleSku(skuMap, optionValue) {
    var key;
    var upperValue;

    if (!skuMap || typeof skuMap !== 'object') {
      return '';
    }

    upperValue = $.trim(String(optionValue)).toUpperCase();

    for (key in skuMap) {
      if (Object.prototype.hasOwnProperty.call(skuMap, key)) {
        if ($.trim(String(key)).toUpperCase() === upperValue) {
          return skuMap[key];
        }
      }
    }

    return '';
  }

  function getBundleSelectedOptions($form) {
    var selectedOptions = [];

    $form.find('.single-option-selector').each(function () {
      selectedOptions.push($(this).val());
    });

    return selectedOptions;
  }

  function findBundleVariant(variants, selectedOptions) {
    var matchedVariant = null;

    $.each(variants, function (_, variant) {
      var matched = true;

      if (!variant.options || variant.options.length !== selectedOptions.length) {
        return true;
      }

      $.each(selectedOptions, function (index, value) {
        if (String(variant.options[index]) !== String(value)) {
          matched = false;
          return false;
        }
      });

      if (matched) {
        matchedVariant = variant;
        return false;
      }
    });

    return matchedVariant;
  }

  function updateBundleSkuProperties($form, skuMap) {
    var $selectors = $form.find('.single-option-selector');

    $form.find('.sku-property-input').each(function () {
      var $input = $(this);
      var index = parseInt($input.data('option-index'), 10);
      var $selector = $selectors.eq(index);

      if ($selector.length) {
        $input.val(lookupBundleSku(skuMap, $selector.val()));
      }
    });
  }

  function updateBundleVariant($form) {
    var state = getBundleState($form);
    var selectedOptions = getBundleSelectedOptions($form);
    var matchedVariant = findBundleVariant(state.variants, selectedOptions);
    var $idInput = $form.find('[name="id"]').first();
    var $submitBtn = $form.find('.btn_add_to_bag').first();

    if (matchedVariant) {
      $idInput.val(matchedVariant.id);

      if (matchedVariant.available) {
        $submitBtn.prop('disabled', false).removeClass('disabled').text('ADD TO BAG');
      } else {
        $submitBtn.prop('disabled', true).addClass('disabled').text('SOLD OUT');
      }
    } else {
      $idInput.val('');
      $submitBtn.prop('disabled', true).addClass('disabled').text('UNAVAILABLE');
    }

    updateBundleSkuProperties($form, state.skuMap);

    return !!$idInput.val();
  }

  $('.js-bundle-form').each(function () {
    updateBundleVariant($(this));
  });

  $(document).on('change input', '.js-bundle-form .single-option-selector', function () {
    updateBundleVariant($(this).closest('.js-bundle-form'));
  });

  $(document).on('mousedown touchstart click', '.js-bundle-form .btn_add_to_bag', function () {
    updateBundleVariant($(this).closest('.js-bundle-form'));
  });

  $(document).on('submit', '.js-bundle-form', function (event) {
    var $form = $(this);
    var isValid = updateBundleVariant($form);

    if (!isValid) {
      event.preventDefault();
      alert('選択された組み合わせに対応する商品が見つかりませんでした。');
    }
  });
});